import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    badge: {
        pointerEvents: 'none',
    },
});
